import type { InviteDetails } from '@/types/invite'

/** GET /invite/:code may return the row directly or `{ data: row }` depending on client/wrapper. */
export function unwrapInvitePayload(payload: unknown): InviteDetails {
  if (!payload || typeof payload !== 'object') {
    return {} as InviteDetails
  }
  const record = payload as Record<string, unknown>
  if (
    typeof record.first_name === 'string' ||
    typeof record.invite_fees_html === 'string' ||
    typeof record.invite_code === 'string'
  ) {
    return record as InviteDetails
  }
  if (record.data && typeof record.data === 'object') {
    return record.data as InviteDetails
  }
  return record as InviteDetails
}
